import { getStore } from "@/domains/local-db/global/configure";
import config from "@/domains/local-db/global/general/config";
import LocalDbTableAdapter from "@/domains/local-db/lib/LocalDbTableAdapter";

const table = new LocalDbTableAdapter(getStore, config.TABLE_NAME);

export default table;
